import { useAdminFormMasters } from './hooks/useAdminFormMasters';
import { useAdminFormCatalog } from './hooks/useAdminFormCatalog';

/**
 * Reference + master data for admin add/edit user forms (facade over smaller hooks — ISP-friendly splits).
 */
export const useFormData = (token) => {
  const masters = useAdminFormMasters(token);
  const catalog = useAdminFormCatalog(token);

  return {
    ...catalog,
    ...masters
  };
};
